<template>
  <div class="sp_step">
    <el-form :model="stepOneForm"
             :rules="stepOneRules"
             ref="stepOneForm"
             @submit.native.prevent>
      <el-form-item :label="$t('loginModule.email')+'：'"
                    prop="email">
        <el-input type="text"
                  v-model="stepOneForm.email"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button :loading="sendLoad"
                   type="primary"
                   style="width:100%;height:48px; font-size:16px; margin-top:5px;"
                   @click="nextStep('stepOneForm')"
                   :disabled="timeOut>0">{{timeOut>0?timeOut+'s':$t('loginModule.next')}}</el-button>
        <div class="sp_login_skip">
          <router-link :to="{path:'/login'}">{{$t("loginModule.login")}}</router-link>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { sendForgetPwdEmail, checkHavetEmail } from '@/api/loginApi.js'
import { registerEncrypt } from '@/utils/encrypt.js'
export default {
  name: 'stepOne',
  props: {
    forgotParams: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    var checkEmail = (rules, value, callback) => {
      const Reg =
        /^([a-zA-Z0-9_+-.])+@([a-zA-Z0-9_+-])+((\.[a-zA-Z0-9_-]{2,20}){1,4})$/
      if (!value) {
        return callback(new Error('Please input email.'))
      } else {
        if (Reg.test(value)) {
          checkHavetEmail(registerEncrypt(value)).then((res) => {
            if (res.code == 500) {
              return callback(new Error(res.msg))
            } else {
              return callback()
            }
          })
        } else {
          return callback(
            new Error(
              'Your email format is wrong, please check and try it again.'
            )
          )
        }
      }
    }
    return {
      stepOneForm: {
        email: '',
      },

      stepOneRules: {
        email: [{ required: true, validator: checkEmail, trigger: 'blur' }],
      },

      timeOut: 0,
      sendLoad: false,
    }
  },

  methods: {
    //下一步
    nextStep(stepOneForm) {
      this.$refs[stepOneForm].validate((valid) => {
        if (valid) {
          this.sendLoad = true
          let params = JSON.parse(JSON.stringify(this.stepOneForm.email))
          params = registerEncrypt(params)
          sendForgetPwdEmail(params)
            .then(() => {
              this.sendLoad = false
              this.$message({
                type: 'success',
                message: 'Send successfully',
              })
              this.$emit('stepOne', {
                email: this.stepOneForm.email,
                sendSuccess: true,
              })
              this.$ls.set('timeOut', 59)
            })
            .catch(() => {
              this.sendLoad = false
              this.$ls.set('timeOut', 0)
            })
        }
      })
    },

    //倒计时
    countDown() {
      const timeNum = 59
      let timer = setInterval(() => {
        if (this.timeOut > 0 && this.timeOut <= timeNum) {
          this.timeOut--
          this.$ls.set('timeOut', this.timeOut)
        } else {
          clearInterval(timer)
          this.timer = null
        }
      }, 1000)
    },
  },

  activated() {
    let timeNum = this.$ls.get('timeOut')
    if (timeNum) {
      this.timeOut = timeNum
    }
    this.countDown()
    this.stepOneForm.email = this.forgotParams.email
  },
}
</script>

<style>
</style>